export default {
  sidebarOpen: state => state.sidebarOpen,
  darkMode: state => state.darkMode,
  activeLoaders: state => moduleName => state.activeLoaders[moduleName]
};
